"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLeagueTeamsGroupDto = instanceOfLeagueTeamsGroupDto;
exports.LeagueTeamsGroupDtoFromJSON = LeagueTeamsGroupDtoFromJSON;
exports.LeagueTeamsGroupDtoFromJSONTyped = LeagueTeamsGroupDtoFromJSONTyped;
exports.LeagueTeamsGroupDtoToJSON = LeagueTeamsGroupDtoToJSON;
exports.LeagueTeamsGroupDtoToJSONTyped = LeagueTeamsGroupDtoToJSONTyped;
var TeamsListDataDto_1 = require("./TeamsListDataDto");
/**
 * Check if a given object implements the LeagueTeamsGroupDto interface.
 */
function instanceOfLeagueTeamsGroupDto(value) {
    if (!('leagueCode' in value) || value['leagueCode'] === undefined)
        return false;
    if (!('teams' in value) || value['teams'] === undefined)
        return false;
    return true;
}
function LeagueTeamsGroupDtoFromJSON(json) {
    return LeagueTeamsGroupDtoFromJSONTyped(json, false);
}
function LeagueTeamsGroupDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'leagueCode': json['leagueCode'],
        'leagueName': json['leagueName'] == null ? undefined : json['leagueName'],
        'teams': (json['teams'].map(TeamsListDataDto_1.TeamsListDataDtoFromJSON)),
    };
}
function LeagueTeamsGroupDtoToJSON(json) {
    return LeagueTeamsGroupDtoToJSONTyped(json, false);
}
function LeagueTeamsGroupDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'leagueCode': value['leagueCode'],
        'leagueName': value['leagueName'],
        'teams': (value['teams'].map(TeamsListDataDto_1.TeamsListDataDtoToJSON)),
    };
}
